import { render, staticRenderFns } from "./carSeg.vue?vue&type=template&id=0fd02c2f&scoped=true&"
import script from "./carSeg.vue?vue&type=script&lang=js&"
export * from "./carSeg.vue?vue&type=script&lang=js&"
import style0 from "./carSeg.vue?vue&type=style&index=0&id=0fd02c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd02c2f",
  null
  
)

export default component.exports